export default __webpack_public_path__ + "static/media/theme.d557a341.svg";